module.exports = __webpack_public_path__ + "assets/chevin-thin.0959954c90704d890426f0fbcb6e1d16.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OP/chevin-thin.eot
// module id = 53
// module chunks = 0